export const POSTULATION_STATUS = {
  SEND: 'SEND',
  ALLOWED: 'ALLOWED',
  DENIED: 'DENIED',
  NEGATED: 'NEGATED'
} as const;

export const POSTULATION_ACTION_TYPES = {
  ACCEPTED: 'POSTULACION_ACCEPTED',
  NEGATED: 'POSTULACION_NEGATED'
} as const;

export type PostulationStatus = typeof POSTULATION_STATUS[keyof typeof POSTULATION_STATUS];

export const POSTULATION_STATUS_LABELS: Record<PostulationStatus, string> = {
  [POSTULATION_STATUS.SEND]: 'Pendiente',
  [POSTULATION_STATUS.ALLOWED]: 'Aceptada',
  [POSTULATION_STATUS.DENIED]: 'Rechazada',
  [POSTULATION_STATUS.NEGATED]: 'Rechazada'
};

export const POSTULATION_SECTIONS = {
  RECEIVED: 0,
  ACCEPTED: 1,
  DENIED: 2
} as const;

